module.exports = __webpack_public_path__ + "static/media/Music-and-society.ab613a5c.jpg";